import type { Answers, Groups } from "../../../../features/questionnaire";
import { isNoCoverValue } from "../../Section/Question/QuestionFactory/questions/PersonalisedCoverQuestion/constants";

export type ShouldValidateNonVisibleParams = {
  questionName: string;
  questionVisible: boolean | string | number;
  groups?: Groups;
  answers?: Answers;
};

/**
 * Check if a question should be validated despite having visibilityMap[name] === false.
 * Currently handles personalised cover child questions (when accordion is collapsed).
 */
export const shouldValidateNonVisible = ({
  questionName,
  questionVisible,
  groups,
  answers,
}: ShouldValidateNonVisibleParams): boolean => {
  if (!groups || !answers) return false;

  // Find if this question is a child in a personalised_cover group
  const parentEntry = Object.entries(groups).find(
    ([, group]) =>
      group.kind === "personalised_cover" && group.names.includes(questionName),
  );

  if (!parentEntry) return false;

  const [primaryQuestionName] = parentEntry;
  const primaryAnswer = answers[primaryQuestionName];

  // Check if cover is selected (answer is not a "no cover" value)
  const hasCover = primaryAnswer && !isNoCoverValue(primaryAnswer);

  // Validate if cover is selected and the question itself is visible (by Chopin)
  return !!hasCover && !!questionVisible;
};
